import { render, staticRenderFns } from "./UserDetailsComponentView.vue?vue&type=template&id=a510484a&scoped=true"
import script from "./UserDetailsComponentView.vue?vue&type=script&lang=js"
export * from "./UserDetailsComponentView.vue?vue&type=script&lang=js"
import style0 from "./UserDetailsComponentView.vue?vue&type=style&index=0&id=a510484a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a510484a",
  null
  
)

export default component.exports